import axios from "axios";

export default {
	data() {
		return {
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			mxChartConfig: null,
			showOverlay: true,
			testData: [],
			// palettes: {
			// 	standard: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272"],
			// 	vintage: ["#d87c7c", "#919e8b", "#d7ab82", "#6e7074", "#61a0a8", "#efa18d"],
			// 	cool: ["#007bff", "#20c997", "#17a2b8", "#6610f2", "#00d084", "#abb8c3"],
			// 	warm: ["#ff8b00", "#ff5e3a", "#ff2a68", "#ffdb58", "#c0392b", "#e67e22"],
			// 	neon: ["#00f5d4", "#00bbf9", "#9b5de5", "#f15bb5", "#fee440", "#312244"],

			// 	// Nuove Palette
			// 	grayscale: ["#212529", "#495057", "#6c757d", "#adb5bd", "#ced4da", "#e9ecef"], // Da scuro a chiaro
			// 	pastel: ["#ffadad", "#ffd6a5", "#fdffb6", "#caffbf", "#9bf6ff", "#bdb2ff"], // Colori morbidi
			// 	dark: ["#001219", "#005f73", "#0a9396", "#94d2bd", "#e9d8a6", "#ee9b00"], // Palette profonda (Oceanic)
			// 	nature: ["#264653", "#2a9d8f", "#e9c46a", "#f4a261", "#e76f51", "#8ab17d"], // Colori terra e bosco
			// 	corporate: ["#0d47a1", "#1565c0", "#1976d2", "#1e88e5", "#2196f3", "#42a5f5"], // Diverse sfumature di blu business
			// },
			palettes: {
				standard: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc", "#749f83", "#ca8622", "#c23531"],
				vintage: ["#d87c7c", "#919e8b", "#d7ab82", "#6e7074", "#61a0a8", "#efa18d", "#787464", "#cc7e63", "#724e58", "#4b565b", "#8d98b3", "#e6b600"],
				cool: ["#007bff", "#20c997", "#17a2b8", "#6610f2", "#00d084", "#abb8c3", "#0056b3", "#138496", "#28a745", "#fd7e14", "#6f42c1", "#e83e8c"],
				warm: ["#ff8b00", "#ff5e3a", "#ff2a68", "#ffdb58", "#c0392b", "#e67e22", "#d35400", "#f1c40f", "#e74c3c", "#f39c12", "#fb8c00", "#ffb300"],
				neon: ["#00f5d4", "#00bbf9", "#9b5de5", "#f15bb5", "#fee440", "#312244", "#3a0ca3", "#4361ee", "#4cc9f0", "#7209b7", "#ff4d6d", "#00ff41"],
				grayscale: ["#212529", "#343a40", "#495057", "#6c757d", "#adb5bd", "#ced4da", "#dee2e6", "#e9ecef", "#f8f9fa", "#f1f3f5", "#e5e7eb", "#d1d5db"], // Da scuro a chiaro
				pastel: ["#ffadad", "#ffd6a5", "#fdffb6", "#caffbf", "#9bf6ff", "#bdb2ff", "#ffc6ff", "#fffffc", "#fb6f92", "#ff85a1", "#ff92bb", "#e1f5fe"], // Colori morbidi
				dark: ["#001219", "#005f73", "#0a9396", "#94d2bd", "#e9d8a6", "#ee9b00", "#ca6702", "#bb3e03", "#ae2012", "#9b2226", "#00344d", "#004b23"], // Palette profonda (Oceanic)
				nature: ["#264653", "#2a9d8f", "#e9c46a", "#f4a261", "#e76f51", "#8ab17d", "#bc6c25", "#dda15e", "#606c38", "#283618", "#588157", "#3a5a40"], // Colori terra e bosco
				corporate: ["#0d47a1", "#1565c0", "#1976d2", "#1e88e5", "#2196f3", "#42a5f5", "#64b5f6", "#90caf9", "#bbdefb", "#01579b", "#0277bd", "#0288d1"], // Diverse sfumature di blu business
			},
		};
	},
	computed: {
		chartOption() {
			if (!this.mxChartConfig) return;

			if (this.$refs.cmpGraphics) {
				this.$refs.cmpGraphics.chart.clear();
			}

			const xField = this.mxChartConfig?.xField;
			const seriesConfigs = JSON.stringify(this.mxChartConfig.seriesConfigs);
			seriesConfigs;
			xField;
			if (!this.mxChartConfig) {
				return;
			}
			if (this.mxChartConfig.graphicType === "pie") {
				return this.getPieGraphic();
			}
			if (this.mxChartConfig.graphicType) {
				return this.getLineBarGraphic();
			} else {
				this.$refs.cmpGraphics.chart.clear();
				return {};
			}
		},
	},
	watch: {
		mxChartConfig: {
			handler(newVal) {
				newVal;
				//this.renderChart(); // Funzione manuale per aggiornare ECharts
			},
			deep: true,
		},
	},
	methods: {
		getToolTip() {
			return { trigger: "item", formatter: "{a} <br/>{b}: <b>{c}</b> ({d}%)" };
		},
		getLegend() {
			return {
				type: "scroll",
				bottom: 10,
				left: "center",
			};
		},
		setMxChartConfig(chartConfig) {
			this.mxChartConfig = chartConfig; //color: colorPalette,
		},
		queryLoadData() {
			let me = this;
			if (!this.mxChartConfig.idQuery) {
				this.showOverlay = false;
				return;
			}
			this.isExecuting = true;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceData + "/" + this.mxChartConfig.idQuery;
			axios.get(link)
				.then((response) => {
					this.testData = [];
					//this.testData = response.data.data;
					this.testData = response.data.data;
					//console.log(JSON.stringify(this.testData));
					this.isExecuting = false;
					this.showOverlay = false;
					if (this.testData.length === 0) {
						this.$bvToast.toast("La query è stata eseguita ma non ha restituito risultati.", { variant: "warning" });
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		aggregateData(legendField, key, aggType = "sum") {
			if (!this.testData || !Array.isArray(this.testData) || !aggType) return [];
			const data = this.testData;
			// 1. Fase di raggruppamento e calcolo preliminare
			const grouped = data.reduce((acc, curr) => {
				//console.log(acc);
				let groupName = curr[legendField] || "NON DEFINITO";
				let val = curr[key] || 0;
				if (!acc[groupName]) {
					acc[groupName] = {
						sum: 0,
						count: 0,
						min: val,
						max: val,
						values: [], // utile per calcoli complessi se necessario
					};
				}
				acc[groupName].sum += val;
				acc[groupName].count += 1;
				acc[groupName].min = Math.min(acc[groupName].min, val);
				acc[groupName].max = Math.max(acc[groupName].max, val);
				return acc;
			}, {});

			// 2. Trasformazione nel formato ECharts { name, value }
			return Object.entries(grouped).map(([name, stats]) => {
				let finalValue;
				switch (aggType.toLowerCase()) {
					case "count":
						finalValue = stats.count; // Numero di record nel gruppo
						break;
					case "min":
						finalValue = stats.min;
						break;
					case "max":
						finalValue = stats.max;
						break;
					case "avg":
						finalValue = stats.count > 0 ? (stats.sum / stats.count).toFixed(2) : 0;
						break;
					case "sum":
					default:
						finalValue = stats.sum;
						break;
				}
				return {
					name: name,
					value: Number(finalValue), // Assicura che sia un numero per il grafico
				};
			});
		},
		getPieGraphic() {
			return {
				tooltip: this.getToolTip(),
				legend: this.getLegend(),
				color: this.palettes[this.mxChartConfig.colorPalette],
				// --- AGGIUNGI QUESTI PER RESETTARE L'ISTOGRAMMA ---
				xAxis: { show: false, data: [] },
				yAxis: { show: false },
				grid: { show: false },
				// ------------------------------------------------
				series: this.getPieSeries(),
			};
		},

		getLineBarGraphic() {
			const config = this.mxChartConfig;
			const data = this.testData;

			// 1. CONTROLLO DI SICUREZZA
			if (!config || !config.seriesConfigs?.length || !data?.length) return {};

			// 2. RECUPERO CAMPI DAL JSON
			const axisField = config.xField; // es. 'regime' (Asse X)
			const sCfg = config.seriesConfigs[0];
			const seriesField = sCfg.serieField; // es. 'stato_attuale' (Legenda)
			const valueField = sCfg.yvalue; // es. 'numero' (Valore)
			const aggType = sCfg.agg || "sum"; // es. 'sum', 'count', 'avg'

			// 3. ESTRAZIONE LABEL UNICHE (X e Serie)
			const xLabels = [...new Set(data.map((item) => String(item[axisField] || "N/A")))].sort();
			const seriesLabels = [...new Set(data.map((item) => String(item[seriesField] || "N/A")))].sort();

			// 4. RAGGRUPPAMENTO E AGGREGAZIONE (Pre-calcolo)
			// Creiamo un oggetto dove la chiave è "X-Serie" per un accesso fulmineo
			const grouped = data.reduce((acc, curr) => {
				const xVal = String(curr[axisField] || "N/A");
				const sVal = String(curr[seriesField] || "N/A");
				const key = `${xVal}_${sVal}`;
				const val = Number(curr[valueField]) || 0;

				if (!acc[key]) {
					acc[key] = { sum: 0, count: 0, min: val, max: val };
				}
				acc[key].sum += val;
				acc[key].count += 1;
				acc[key].min = Math.min(acc[key].min, val);
				acc[key].max = Math.max(acc[key].max, val);
				return acc;
			}, {});

			// 5. COSTRUZIONE SERIE PER ECHARTS
			const series = seriesLabels.map((sName) => {
				return {
					name: sName,
					type: sCfg.type || "bar",
					emphasis: { focus: "series" },
					data: xLabels.map((xName) => {
						const comboKey = `${xName}_${sName}`;
						const stats = grouped[comboKey];

						if (!stats) return 0;

						// Calcolo in base al tipo di aggregazione scelto
						switch (aggType.toLowerCase()) {
							case "count":
								return stats.count;
							case "min":
								return stats.min;
							case "max":
								return stats.max;
							case "avg":
								return stats.count > 0 ? Number((stats.sum / stats.count).toFixed(2)) : 0;
							case "sum":
							default:
								return stats.sum;
						}
					}),
				};
			});

			// 6. RITORNO OPZIONI ECHARTS
			return {
				tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
				legend: { show: true, bottom: 10, type: "scroll" },
				color: this.palettes[this.mxChartConfig.colorPalette],
				// 2. DEFINIZIONE DELLA GRIGLIA (Cruciale)
				grid: {
					top: config.gridTop ? config.gridTop + "%" : "10%",
					bottom: config.gridBottom ? config.gridBottom + "%" : "15%",
					left: config.gridLeft ? config.gridLeft + "%" : "3%",
					right: config.gridRight ? config.gridRight + "%" : "4%",
					containLabel: true,
				},
				// grid: {
				// 	top: "10%", // Spazio per il titolo
				// 	left: "3%", // Margine sinistro
				// 	right: "4%", // Margine destro
				// 	bottom: "15%", // AUMENTA QUESTO VALORE (es. 20% o 80px) se le scritte sono lunghe
				// 	containLabel: true, // Forza gli assi a stare dentro la griglia
				// },
				xAxis: {
					type: "category",
					data: xLabels,
					axisLabel: { rotate: xLabels.length > 5 ? 45 : 0 },
				},
				yAxis: { type: "value" },
				series: series,
			};
		},
		getPieSeries() {
			const series = [];
			this.mxChartConfig.seriesConfigs.forEach((element) => {
				const localData = this.aggregateData(this.mxChartConfig.xField, element.yvalue, element.agg);
				let radiusInternal = element.radiusInternal ? element.radiusInternal + "%" : "45%";
				let radiusExternal = element.radiusExternal ? element.radiusExternal + "%" : "75%";
				let serie = {
					name: this.mxChartConfig.title,
					type: "pie",
					radius: [radiusInternal, radiusExternal],
					avoidLabelOverlap: false,
					label: {
						show: false,
						position: "left",
					},
					emphasis: {
						label: {
							show: true,
							fontSize: 18,
							fontWeight: "bold",
						},
					},
					labelLine: {
						show: true,
					},
					data: localData,
				};
				series.push(serie);
				if (element.viewTotal) {
					series.push({
						name: this.mxChartConfig.title + " - Totale",
						type: "pie",
						selectedMode: "single",
						radius: [0, "37%"],
						label: {
							position: "center",
							formatter: "{b|{b}}\n{a|{c}}",
							rich: {
								a: {
									color: "#FFF",
									fontSize: 32,
									fontWeight: "bold",
									lineHeight: 30,
								},
								b: {
									color: "#FFF",
									fontSize: 15,
									fontWeight: "bold",
									lineHeight: 45,
								},
							},
						},
						labelLine: {
							show: true,
						},
						data: [{ value: localData.reduce((acc, obj) => acc + obj.value, 0), name: "Totale" }],
					});
				}
			});
			return series;
		},
	},
};
